export default {
  release: '18.7',
  date: 'December 2025',
  releasePostUrl: 'https://docs.gitlab.com/releases/18/gitlab-18-7-released/#this-months-notable-contributor-david-aniebo',
  contributors: [
    {
      name: 'David Aniebo',
      gitlabUsername: 'webmekanic',
    },
  ],
  writeUp: `We're excited to recognize David Aniebo as our 18.7 Notable Contributor for his impactful contributions to GitLab
product planning capabilities and the [contributor platform](https://contributors.gitlab.com).

David's work on [improving work item list functionality](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/207549)
demonstrates his technical expertise and dedication to enhancing the user experience for GitLab planning features.
This contribution helps teams better organize and manage their work items, making project planning more efficient for
thousands of GitLab users.

Beyond code contributions, David has been a consistent supporter of the contributor platform, helping to improve the
experience for community contributors. His collaborative approach and responsiveness have earned praise from multiple
team members across different groups.

"David has done some fantastic work helping out with some Product Planning group efforts, and we are very thankful for
his contributions," shared Nick Brandt, Engineering Manager for Product Planning.

Thank you, David, for your valuable contributions to GitLab and for being such a collaborative member of our community!
We look forward to your continued involvement.`,
};
